<ncp-table #autonomyInvalidity [(options)]="options"></ncp-table>
